import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'; //, ModalDismissReasons
import { FormBuilder} from '@angular/forms'; // FormGroup, FormControl, , Validators
import { Router } from '@angular/router'; //, NavigationExtras

import { SigninUpComponent } from '../signin-up/signin-up.component';

// PROVIDER
import {BasicProvider} from '../providers/basic/basic';
import {UserProvider} from '../providers/user/user';

@Component({
  selector: 'app-inrheader',
  templateUrl: './inrheader.component.html',
  styleUrls: ['./inrheader.component.css']
})


export class InrheaderComponent implements OnInit {

  countries:any;
  isCollapsed = true;
  isNavbarCollapsed = false;
  closeResult: string;
  airfrightForm;
  calculated_price;
  loginForm;
  signupForm;
  isDisabled = true;

  constructor(
    private modalService: NgbModal,
    public builder:FormBuilder,
    public bp:BasicProvider, 
    public up:UserProvider,
    public router: Router,
  ) {
    
    //this.setsLoginForm();
    //this.setSignupForm();
  }

  toggleMenu() {
    this.isCollapsed = !this.isCollapsed;
  }

  ngOnInit() {
  }

  logout(){
    this.up.logout();
  }

  signupOpen(content) {
    this.bp.model_type = 'signup';
    this.bp.model = this.modalService.open(SigninUpComponent, { windowClass: 'signUp-modal' });
    return false;
  }

  signinOpen(content) {
    this.bp.model_type = 'signin';
    this.bp.model = this.modalService.open(SigninUpComponent, { windowClass: 'signUp-modal' });
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/inrheader/inrheader.component.ts